import { Button } from '@simplywallst/ui-core';
import DangerSolid from '@simplywallst/ui-core/icons/DangerSolid';

import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import { SWS_HOST } from '@/constants';

type Props = {
  narrativeId: string;
  canonicalUrl: string;
};

export const ReportNarrative = ({ narrativeId, canonicalUrl }: Props) => {
  const makeTypeformPopup = useTypeformDrawer('QcdSFNqs', {
    narrativeId,
    narrativeurl: `${SWS_HOST}${canonicalUrl}`,
    valuationtype: 'USER_DEFINED',
  });
  return (
    <Button
      alignIcon="left"
      display="inline"
      onClick={makeTypeformPopup}
      styleType="passive"
    >
      <DangerSolid />
      Report
    </Button>
  );
};
